/* eslint-disable react/no-children-prop */
import React, { useEffect } from 'react';
import { message } from '$/components/Message';
import RoboneoContext from '$/pages/RoboneoContext';
import { InitLoginConfig, useOfficialStore } from '$/store/useOfficialStore';
import { isMobile } from '$/utils';
import { useCommonStore } from '@/store/useCommonStore';

import { getEnv, navigate, pageAgent } from '@/common/agents';
import useIsClient from '@/hooks/useIsClient';

export default function FeatureInit() {
  const isClient = useIsClient();
  const toLogin = useCommonStore((state) => state.toLogin);
  const initUserInfo = useCommonStore((state) => state.initUserInfo);
  const init = useCommonStore((state) => state.init);
  const initialized = useCommonStore((state) => state.initialized);
  const disposeOfflineListener = useCommonStore(
    (state) => state.disposeOfflineListener,
  );
  const isUserLoggedIn = useOfficialStore((state) => state.isUserLoggedIn());
  const { locationName } = pageAgent.getCurrentPage() || {};

  const loadVconsole = async () => {
    if (isMobile() && process.env.NEXT_PUBLIC_ENVIRONMENT !== 'release') {
      const VConsole = await import('vconsole');
      // eslint-disable-next-line no-new, new-cap
      new VConsole.default();
    }
  };

  useEffect(() => {
    InitLoginConfig({
      toLogin: async () => {
        await toLogin();
        initUserInfo();
      },
    });
    init();
    loadVconsole();
  }, []);
  // 注册chat的参数

  useEffect(() => {
    if (
      initialized
      && !isUserLoggedIn
      && locationName
      && (locationName === 'studio' || locationName === 'ai_flow')
    ) {
      message.info('RoboNeo_Web_login_check_text');
      navigate({
        mode: 'url',
        url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
        replace: true,
      });
    }
  }, [locationName, initialized, isUserLoggedIn]);
  /** 页面卸载时释放离线监听，Sentry 已由应用公共入口统一初始化。 */
  useEffect(() => () => {
    disposeOfflineListener();
  }, []);
  if (!isClient) {
    return null;
  }
  return (
    <RoboneoContext enableVip children={null} />
  );
}
